import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AngularMaterialModule } from '../angular-material/angular-material.module';
import { PipesModule } from '@app/pipes/pipes.module';

import { MintNotificationComponent } from './mint-notification/mint-notification.component';
import { NotificationGridComponent } from './notification-grid/notification-grid.component';
import { NotificationProfileComponent } from './notification-profile/notification-profile.component';
import { NotificationFormComponent } from './notification-form/notification-form.component';
import { AchievementNotificationComponent } from './achievement-notification/achievement-notification.component';
import { ConfettiAnimationComponent } from './achievement-notification/confetti-animation/confetti-animation.component';
import { IncomingMessageNotificationComponent } from './incoming-message-notification/incoming-message-notification.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AngularMaterialModule,
        RouterModule,
        PipesModule
    ],
    declarations: [MintNotificationComponent, NotificationGridComponent, NotificationProfileComponent, NotificationFormComponent, AchievementNotificationComponent, ConfettiAnimationComponent, IncomingMessageNotificationComponent],
    exports: [MintNotificationComponent, NotificationGridComponent, NotificationProfileComponent, NotificationFormComponent, AchievementNotificationComponent, IncomingMessageNotificationComponent]
})
export class NotificationsModule { }
